module.exports = __webpack_public_path__ + "static/media/react-logo-transparent.4644e8f0.png";